import React, { Fragment } from "react";
import { Breadcrumbs } from "../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ListHeader from "./ListHeader";

import TableData from "./TableData";
import UserActivityProvider from "./ContextProvider/UserActivityProvider";

export default function ActivityReport() {
  return (
    <UserActivityProvider>
      <Fragment>
        <Breadcrumbs
          mainTitle="Actividad de usuario"
          parent="Reportes"
          title="Actividad de usuario"
        />
        <Container fluid={true} className="todo-wrap">
          <ListHeader />

          <Row>
            <Col xl="12">
              <Card className="todo">
                <CardBody>
                  <div className="todo">
                    <div className="todo-list-wrapper">
                      <div className="todo-list-container">
                        <TableData />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </UserActivityProvider>
  );
}
